import Validators, { addValidator } from 'redux-form-validators';
Validators.defaultOptions = {
    ...Validators.defaultOptions,
    caseSensitive: false,
};
Validators.messages = {
    ...Validators.messages,
    presence: 'Required',
    tooShort: '{count, number} Character Minimum',
    tooLong: '{count, number} Character Maximum',
};
export const doesNotIncludeHttp = addValidator({
    defaultMessage: 'Do not include "http://"',
    validator: function (_, value) {
        return /^(?!(http:\/\/|https:\/\/)).*$/g.test(value);
    },
});
export const validUrlWithoutProtocol = addValidator({
    defaultMessage: 'Invalid URL',
    validator: function (options, value) {
        return ((options.allowBlank && !value) ||
            /^[-a-zA-Z0-9@:%_+.~#?&/=]{2,256}\.[a-z]{2,4}((\/|\?)[-a-zA-Z0-9@:%_+.~#?&/=]*)?$/gi.test(value));
    },
});
export const validUrl = addValidator({
    defaultMessage: 'Invalid URL',
    validator: function (options, value) {
        return ((options.allowBlank && !value) ||
            /^(http:\/\/|https:\/\/)[-a-zA-Z0-9@:%_+.~#?&/=]{2,256}\.[a-z]{2,4}((\/|\?)[-a-zA-Z0-9@:%_+.~#?&/=]*)?$/gi.test(value));
    },
});
export const validTime = addValidator({
    defaultMessage: 'Invalid time specified',
    validator: function (options, value) {
        return ((options.allowBlank && !value) ||
            /^((1[0-2]|0[1-9]):([0-5][0-9]) ([AaPp][Mm]))$/g.test(value));
    },
});
export { Validators };
export * from 'redux-form-validators';
//# sourceMappingURL=formValidators.js.map